import React from 'react';
import { Link, NdsThemeProvider } from '@ntuctech/devex-tangram';
import styled from 'styled-components';
import QRCode from 'qrcode';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import Accordion from '../Accordion';
import Qrcode from '../icons/svg/Qrcode.svg';

const MainContainer = styled.div`
  height: 89vh;
  background: #f6f6f6 !important;
`;
const CardContainer = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
    justify-content: center;
    max-width: 100%;
    margin: 1rem auto 0;
  }

  ${SCREEN_SIZE.Only.Tablet} {
    > :first-child {
      width: 24.5rem;
    }
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: '6rem';
  }

  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: '6rem';
  }
`;
const WhiteBox = styled.div`
  background-color: #fff;
  padding-top: 45px;
  padding-bottom: 45px;
  margin-bottom: 1rem;
  margin-top: 30px;
  @media screen and (min-width: 600px) {
    border: 1px solid #eaeaea;
  }
`;

const RmvInnerPad = styled.div`
  @media screen and (min-width: 768px) {
    > div:nth-child(1) {
      padding: 2rem 23rem;
    }
  }
`;

const StyledText = styled.div`
  line-height: 1.25rem;
  padding: 0 1rem 1rem 1rem;
  a {
    color: var(--bold-title-color);
    font-weight: 700;
  }
`;

const WrpDiv = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    flex: 1;
    margin-bottom: 0;
  }

  ${SCREEN_SIZE.From.Desktop} {
    flex: 0;
    flex-basis: 100%;
    padding-bottom: 8px;
    max-width: 980px;
  }
`;
const StyledQrCodeWrapper = styled.div`
  position: relative;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  canvas {
    position: relative;
    z-index: 20;
  }
  &[data-error-type] {
    &:before {
      content: attr(data-error-type);
      position: absolute;
      top: 24%;
      left: 46%;
      color: #c70c0a;
      font-size: 2.5rem;
      font-weight: 700;
      z-index: 1;
    }
    &:after {
      content: attr(data-error-message);
      position: absolute;
      top: 44%;
      left: 41.5%;
      color: #c70c0a;
      font-size: 1rem;
      line-height: 1.5;
      font-weight: 700;
      z-index: 1;
      width: 10rem;
      text-align: center;
    }
  }
`;

const StyledCanvasWrapper = styled.div`
  text-align: center;
  opacity: 0.1;
  ${SCREEN_SIZE.Below.MobileL} {
    padding: 2.5rem 2rem 2.75rem;
  }
  ${SCREEN_SIZE.From.Tablet} {
    &[data-error-type] {
      padding-bottom: 2.5rem;
    }
  }
`;

const VoucherError = () => {
  const canvasRef = React.useRef();

  React.useEffect(() => {
    QRCode.toCanvas(canvasRef.current, Qrcode.src, {
      width: 200,
      margin: 0,
    });
  });

  return (
    <>
      {/* <Layout></Layout> */}
      <MainContainer data-testid="voucher-error">
        <CardContainer>
          <WrpDiv>
            <NdsThemeProvider>
              <WhiteBox>
                <RmvInnerPad>
                  <StyledQrCodeWrapper
                    data-error-message="The voucher you are looking for cannot be found."
                    data-error-type="404"
                  >
                    <StyledCanvasWrapper>
                      <canvas ref={canvasRef} />
                    </StyledCanvasWrapper>
                  </StyledQrCodeWrapper>
                </RmvInnerPad>
              </WhiteBox>
              <Accordion title="Need help ?" expand>
                <StyledText>
                  <Link
                    size="l"
                    href="https://help.fairprice.com.sg/hc/en-us/requests/new?ticket_form_id=360000029352"
                    target="_blank"
                    rel="noopener noreferrer"
                    css="margin: 0 0.3125rem"
                  >
                    Drop us a message.
                  </Link>
                  {`Copy the URL above.You'll need to paste it in the 'Tell us more' field.`}
                </StyledText>
              </Accordion>
            </NdsThemeProvider>
          </WrpDiv>
        </CardContainer>
      </MainContainer>
    </>
  );
};
export default VoucherError;
